// Angular
import { Injectable } from '@angular/core';

// Interfaces
import { IIncident, INewIncident, IUpdatedIncident } from '../../interfaces/seacom/incident';

// Services
import { ApiNodeService } from './templates/apinode.service';
import { SeacomApiService } from './seacom-api.service';


@Injectable({
  providedIn: 'root'
})
export class IncidentsService extends ApiNodeService<IIncident, INewIncident, IUpdatedIncident> {
  node = 'incidents';

  constructor(public seacomApiService: SeacomApiService) {
    super(seacomApiService);
  }

}
